import React from 'react';
import PropTypes from 'prop-types';
/* components */
import ScrollArea from '../../components/scroll-area/scroll-area';
/* assets */
import logoSrc from '../../assets/images/orbitmi_logo.svg';
/* styles */
import './home.scss';

function HomePage(props) {
    const { allowedDomains, tenantInfo, version } = props;
    return (
        <div className="sten-content sten-home-page">
            <div className="sten-content__header">
                <h1 className="sten-content__title text-uppercase">Tenant information</h1>
            </div>
            <ScrollArea className="sten-content__body sten-content__body--with-bg text-center">
                <div className="sten-content__segment">
                    <img src={logoSrc} className="sten-home-page__logo" alt="OrbitMI" />
                </div>
                <div className="sten-content__segment">
                    <h1>
                        {`Welcome to the ${tenantInfo.value.name} server with`
                            + ` ADFS integration over SAML protocol identity (${version}) site`}
                    </h1>
                </div>
                <div className="sten-content__segment">
                    <section className="sten-content__section">
                        <h3>
                            <span>IdentityServer publishes a </span>
                            <a href="/.well-known/openid-configuration">discovery document</a>
                            <span> where you can find metadata and links to all the endpoints, key material, etc.</span>
                        </h3>
                    </section>
                    <section className="sten-content__section">
                        <h3>
                            You can access identity server using following clients (see <a href="/clients">here</a>).
                        </h3>
                    </section>
                    <section className="sten-content__section">
                        <h3>
                            You can use the following authentication protocols (see <a href="/schemes">here</a>).
                        </h3>
                    </section>
                </div>
                <div className="sten-content__segment">
                    <h2>Allowed domains:</h2>
                    {allowedDomains.map((domain) => (
                        <h2 key={domain} className="text-success">{domain}</h2>
                    ))}
                </div>
            </ScrollArea>
        </div>
    );
}

const emptyArray = [];

HomePage.propTypes = {
    allowedDomains: PropTypes.arrayOf(PropTypes.string),
    tenantInfo: PropTypes.objectOf(PropTypes.any),
    version: PropTypes.string
};

HomePage.defaultProps = {
    allowedDomains: emptyArray,
    tenantInfo: null,
    version: ''
};

export default HomePage;
